import { ViewContratPage } from "@features/rh/contrats/components/ViewContratPage";
import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";
import { Eye } from "lucide-react";

export const Route = createFileRoute("/_app/rh/contrats/$id/view")({
  loader: requirePermission(PERMISSIONS.RH.CONTRATS.VIEW),
  staticData: {
    title: "Voir un contrat",
    icon: Eye,
    permission: PERMISSIONS.RH.CONTRATS.VIEW,
    section: "App",
    showInBreadcrumb: true,
  },
  component: ViewContratPage,
});
